
import { getHotelshoporderDiscomplete } from '@/request/api/base'
export default {
    //namespaced: true,
    state: {
        mainDivLoading: false,
        baseImgUrl: process.env.VUE_APP_BASE_IMG_URL,
        uncompleteOrderList: {
            data: [],
            total: 0
        },
        sidebarIsCollapse: false,    // 侧边菜单是否折叠
        requiredIconNameList: []    // 当前项目中引入icon的名字数组，用来在表单中使用选择器选择icon时使用

    },
    getters: {
    },
    mutations: {
        // 设置加载状态
        setMainDivLoading(state, data) {
            state.mainDivLoading = data
        },
        setUncompleteOrderList(state, data) {
            state.uncompleteOrderList.data = data.data.data
            state.uncompleteOrderList.total = data.data.total
        },
        setSidebarCollapse(state, data) {
            state.sidebarIsCollapse = data
        },
        setRequiredIconNameList(state, data) {
            state.requiredIconNameList = data
        },


    },
    actions: {
        async getUncompleteOrderNum(state) {
            let { data } = await getHotelshoporderDiscomplete()
            if (data.code == 0) {
                state.commit('setUncompleteOrderList', data)
            }
        }
    }
}
